import React from 'react';
import { DataList } from 'commons-ui';
import _get from 'lodash/get';

import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { DASHBOARD_RESOURCES } from 'constant';

import { useLocation } from 'react-router-dom';
import { makeActionHandler } from './actions/handler';
import { makeActionList } from './actions/list';

import useVersionList from './useVersionList';
import { columnConfigs } from './listConfig';

const getId = (): string => {
	const location = useLocation();
	return _get(location, ['state', 'rowData', '_id']);
};

const VersionsList: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const id = getId();
	const actions = getActionList();

	const { getVersionsForExperiment } = useVersionList();

	return (
		<DataList
			fetchData={() => getVersionsForExperiment(id)}
			columnConfigs={columnConfigs}
			rowHeight={150}
			getActionHandler={getActionHandler}
			actions={actions}
			entity={DASHBOARD_RESOURCES.abTest}
			initialSortDirection='ASC'
			initialSortIndex={1}
		/>
	);
};

export default VersionsList;
